import React from "react";
import { connect } from "react-redux";
import { compose, lifecycle } from "recompose";
import {Button, Card, CardText, FontIcon} from "react-md";

import OrgAdmin from "./OrgAdmin";
import OrgDispatcher from "./OrgDispatcher";
import OrgMember from "./OrgMember";

import {
  getAdminOrganizations,
  getDispatcherOrganizations,
  getMemberOrganizations
} from "../../../actions/resourceActions";

import { setDialog } from "../../../actions/dialogActions";
import {TouchTableHeader} from "../../../AtollonTheme/ReactElements";
import {isEmpty, size} from "lodash";

const Organizations = ({
  history,
  organizationsAdmin,
  organizationsDispatcher,
  organizationsMember,
  setDialog
}) => {
  return (
    <div>

        <TouchTableHeader
            titleButtons={(
                <Button
                    raised
                    className="btn btn-primary touchButton-6 touchButton-shape3"
                    label="Nastavit novou organizaci"
                    onClick={() => setDialog("SettingsNewOrganization")}
                />
            )}
        />

        <OrgAdmin history={history} data={organizationsAdmin} />
        <OrgDispatcher history={history} data={organizationsDispatcher} />
        <OrgMember history={history} data={organizationsMember} />

    </div>
  );
};

export default compose(
  connect(
    ({
      resource: {
        organizationsAdmin,
        organizationsDispatcher,
        organizationsMember
      }
    }) => ({
      organizationsAdmin,
      organizationsDispatcher,
      organizationsMember
    }),
    {
      getAdminOrganizations,
      getDispatcherOrganizations,
      getMemberOrganizations,
      setDialog
    }
  ),
  lifecycle({
    async componentWillMount() {
      const {
        getAdminOrganizations,
        getDispatcherOrganizations,
        getMemberOrganizations
      } = this.props;
      getAdminOrganizations();
      getDispatcherOrganizations();
      getMemberOrganizations();
    }
  })
)(Organizations);



// WEBPACK FOOTER //
// ./src/components/settings/organizations/index.js